import { render, staticRenderFns } from "./LedgerLoaderSlot.vue?vue&type=template&id=1edd506c&"
import script from "./LedgerLoaderSlot.vue?vue&type=script&lang=js&"
export * from "./LedgerLoaderSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports